// This directive shows an area graph of network activity on a BoxCaster.
angular.module('app.directives').directive('appBoxcasterProTemperatureGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            boxcasterId: '@'
        },
        controller($scope) {
            $scope.options = {
                renderer: 'multi',
                height: 52,
                min: 0,
            };
            $scope.series = [{
                name: 'ps',
                renderer: 'line',
                data: [],
                color: 'rgba(255,0,0,0.5)'
            }, {
                name: 'pl',
                renderer: 'line',
                data: [],
                color: 'rgba(0,255,255,0.5)'
            }];
            return $scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    _.each($scope.series, s => s.data.length = 0);
                    const keys = ['temperature.ps', 'temperature.pl'];
                    if (newval['temperature.max_touch_plastic']) {
                        keys[0] = 'temperature.max_touch_plastic';
                        $scope.series[0].name = 'plastic';
                        keys[1] = 'temperature.max_touch_metal';
                        $scope.series[1].name = 'metal';
                    } else {
                        $scope.series[0].name = 'ps';
                        $scope.series[1].name = 'pl';
                    }
                    return _.each(keys, (which, idx) => {
                        const data = newval[which];
                        if (data != null) {
                            return Array.prototype.push.apply($scope.series[idx].data, _.map(data, function(v, k) {
                                if (v < 0) {
                                    v = null;
                                }
                                return { x: parseInt(k), y: v };
                            }).sort((a, b) => a.x - b.x));
                        }
                    });
                }
            });
        },

        link(scope, element, attrs, appBoxcasterGraph) {
            _.each([

            ], k => appBoxcasterGraph.registerData(k));
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },

        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_pro_temperature_graph.js